import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitState = {
  editStockData: {
    id?: string | undefined;
    code?: string | undefined;
  };
};

const initialState: InitState = {
  editStockData: {
    id: "",
    code: "",
  },
};

const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    setEditStockData(state, action: PayloadAction<InitState["editStockData"]>) {
      state.editStockData = action.payload;
    },
  },
});
export const stockActions = stockSlice.actions;
export default stockSlice;
